import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link, NavLink } from "react-router-dom"
import BeicaSaKutijama from '../images/BeicaSaKutijama.png';

export default function ThankYou({ onClose, modalText }) {
  const [visible, setVisible] = useState(true);

  const closeModal = () => {
    setVisible(false);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center">
      {/* Dark backdrop */}
      <div
        className={`${visible ? 'opacity-75' : 'opacity-0'
          } fixed inset-0 bg-black transition-opacity duration-300`}
      ><button className='w-full h-screen' onClick={() => closeModal()}></button></div>

      {/* Modal */}
      <div
        className={`${visible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
          } transition-all duration-300 fixed flex mx-5 items-center justify-center`}
      >
        <div className="bg-white p-8 rounded shadow-md">
          <div className='w-full justify-end flex'>
            <button onClick={() => closeModal()}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className='w-full items-center justify-center flex flex-col'>
            <div>
              <img src={BeicaSaKutijama} className="max-w-[400px] w-full" />
            </div>
            <h1 className='font-bold text-xl font-sans '>{modalText.title}</h1>
            <p className='text-center text-gray-800 font-sans text-base  max-w-[270px]'>{modalText.description}</p>
          </div>

          <div className='w-full items-center justify-center flex'>
            <Link to="/">                <button
              className="mt-7 px-2 360:px-16  py-2 bg-brownSkin text-white   focus:outline-none"
              onClick={closeModal}
            >
              Go back to Home
            </button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
